import {
  GroqModel,
  LlmModel,
  OpenaiAssistant,
  OpenaiFunction,
  OpenaiMessage,
  OpenaiModel,
  OpenaiThread,
  OpenaiTool,
} from '../../../../frontend/src/app/core/openai/openai';
import { UrlResponse } from '../request-response';
import { ResourceName } from '../resource-name';

// tslint:disable: variable-name
export const OpenaiGate = {
  resource: ResourceName.openai,
  actions: {
    getAnswer: 'get-answer',
    streamingChat: 'streaming-chat',
    textToSpeech: 'text-to-speech',

    createAssistant: 'create-assistant',
    createThread: 'create-thread',

    createMessage: 'create-message',
    listMessages: 'list-messages',
    retrieveMessage: 'retrieve-message',

    createRun: 'create-run',
    retrieveRun: 'retrieve-run',
  },
};

export type OpenaiTypes = {
  getAnswer: {
    request: GetAnswerRequest;
    response: GetAnswerResponse;
  };
  streamingChat: {
    request: StreamingChatRequest;
    response: undefined;
  };
  textToSpeech: {
    request: TextToSpeechRequest;
    response: UrlResponse;
  };
  createAssistant: {
    request: Partial<OpenaiAssistant>;
    response: OpenaiAssistant;
  };
  createThread: {
    request: CreateThreadRequest | undefined;
    response: OpenaiThread;
  };
  createMessage: {
    request: CreateMessageRequest;
    response: any;
  };
  listMessages: {
    request: ListMessagesRequest;
    response: any;
  };
  retrieveMessage: {
    request: RetrieveMessageRequest;
    response: any;
  };
  createRun: {
    request: CreateRunRequest;
    response: any;
  };
  retrieveRun: {
    request: RetrieveRunRequest;
    response: any;
  };
};

export interface TextToSpeechRequest {
  coreId: string;
  additionalId?: string | number;
  personalBoardId: string;
  workspaceId: string;

  input: string;
  model: 'tts-1' | 'tts-1-hd';
  voice: 'alloy' | 'echo' | 'fable' | 'onyx' | 'nova' | 'shimmer';
}

export interface StreamingChatRequest {
  coreId: string;
  additionalId?: string | number;
  personalBoardId: string;
  workspaceId: string;
  messageList: OpenaiMessage[];
  config?: { model?: string; temperature?: number };
}

export interface RetrieveMessageRequest {
  threadId: string;
  messageId: string;
}

export interface ListMessagesRequest {
  thread_id: string;
}

export interface RetrieveRunRequest {
  thread_id: string;
  run_id: string;
}

export interface CreateRunRequest {
  thread_id: string;
  body: {
    assistant_id: string;
    // It can override the model
    model?: LlmModel;
    instructions?: string;
    tools?: OpenaiTool[];
    metadata?: any;
  };
}

export interface CreateThreadRequest {
  messages?: OpenaiMessage[];
  metadata?: any;
}

export interface CreateMessageRequest {
  thread_id: string;
  message: OpenaiMessage;
}

export interface GetAnswerRequest {
  messageList: OpenaiMessage[];
  config: { openaiModel?: OpenaiModel; groqModel?: GroqModel; temperature?: number; functions?: OpenaiFunction[] };
}

export interface GetAnswerResponse {
  answer: string;
}

export interface ChatWithOpenaiResponse {
  coreId: string;
  content?: string;
  isFinished?: boolean;
  functionName?: string;
}

export interface GetWorkspaceUsageHistoryRequest {
  workspaceId: string;
  startTimeStr: string;
}
